import { StepStatusCaseType, StepNameCase, StepStatusCase } from '@/interfaces';
import { getStatusStep } from '@/lib/casePhases';
import React from 'react';

interface Props {
	stepName: StepNameCase;
	caseSteps: StepStatusCase[] | undefined;
}

export const useStepStatus = ({ stepName, caseSteps }: Props) => {
	const [stepStatus, setStepStatus] =
		React.useState<StepStatusCaseType>('default');

	React.useEffect(() => {
		if (stepName && caseSteps) {
			setStepStatus(getStatusStep(stepName, caseSteps));
		}
	}, [stepName, caseSteps]);

	return {
		stepStatus,
	};
};
